import axios from 'axios'
import * as types from './actionTypes'

export const receiveInfo = (data,queryName) => ({
  type: types.RECEIVE_INFO,
  data,
  queryName
});

export const requestInfo = () => ({
  type: types.REQUEST_INFO
});


export const fetchInfo = (queryNames) => dispatch => {
  dispatch(requestInfo());
  queryNames.forEach(async (item) =>{
    const api = `${window.siteUrl}/api/v1/${item.query}/?format=json`
    try{
      const info = await axios.get(api, {
        params: item.params || null,
        headers: item.headers || null
      })
      dispatch(receiveInfo(info.data, item.query));

      if(item.afterSuccess) {
        item.afterSuccess(info.data);
      }
    }
    catch(e){
        if(item.afterError) {
            item.afterError();
        }
    }
  })
  
};



export const setErrorMessage = message =>({
  type: types.ERROR_MESSAGE,
  message
})
export const resetErrors = () =>({
  type: types.RESET_ERRORS
})





// WEBPACK FOOTER //
// ./src/actions/index.js